import React from 'react'
import { getColor } from 'components/utils'
import { TransProps } from '@lingui/react'

// Type
export type typeInputTextSlim = {
    variant?: string
    id: string
    name?: string
    type?: 'text' | 'number'
    label?: React.ReactElement<TransProps>
    placeholder?: string
    value?: string
    errorMessage?: React.ReactElement<TransProps>
    errorWithoutMessage?: boolean
    required?: boolean
    autoFocus?: boolean
    onBlur?: ( e: React.FocusEvent<HTMLInputElement> ) => void
    labelClassName?: string
    inputClassName?: string
    inputWrapClassName?: string
    maxLength?: number
    maxValue?: number
    minValue?: number
    stepValue?: number
    onChange: ( e: React.ChangeEvent<HTMLInputElement> ) => void
    onKeyDown?: ( e: React.KeyboardEvent<HTMLInputElement> ) => void
    reference?:  React.MutableRefObject<null>
}

// Component
export const InputTextSlim: React.FC<typeInputTextSlim> = ( {
                                                                variant,
                                                                id,
                                                                name,
                                                                label,
                                                                type = 'text',
                                                                placeholder,
                                                                value,
                                                                errorMessage,
                                                                errorWithoutMessage = false,
                                                                required = false,
                                                                autoFocus,
                                                                onBlur,
                                                                labelClassName,
                                                                inputClassName,
                                                                inputWrapClassName,
                                                                maxLength,
                                                                maxValue,
                                                                minValue,
                                                                reference,
                                                                stepValue,
                                                                onChange,
                                                                onKeyDown,
                                                            } ) => {

    const color = getColor(variant)

    const labelStyles = [ 'block mb-1 text-sm font-medium text-gray-700', labelClassName ].join(' ')
    const inputStyles = [ `appearance-none block px-2 py-1 border ${(errorMessage || errorWithoutMessage) ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-${(errorMessage || errorWithoutMessage) ? 'red' : color}-500 focus:border-${(errorMessage || errorWithoutMessage) ? 'red' : color}-500 sm:text-sm`, inputClassName ].join(' ')

    return (
        <>
            {label
                ? <label
                    htmlFor={id}
                    className={labelStyles}
                >
                    {label}
                </label>
                : null
            }

            <div className={inputWrapClassName}>
                <input
                    id={id}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={required}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    className={inputStyles}
                    autoFocus={autoFocus}
                    onBlur={onBlur}
                    maxLength={maxLength}
                    max={maxValue}
                    min={minValue}
                    step={stepValue}
                    ref={reference}
                />
                {errorMessage
                    ? <p className="text-xs mt-1 text-red-500">{errorMessage}</p>
                    : null
                }
            </div>
        </>
    )
}
